<h1>{{ 'filters' | translate }}</h1>
<app-data-options #dataOptions></app-data-options>